export default "<p><%= noSearchCriteriaMsg %></p>";